// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  border-radius: 8px;
  /* width: 90%; */
  /* max-width: 500px; */
  max-height: 90vh;
  overflow: auto;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

.modal-header {
  padding: 20px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-header h3 {
  margin: 0;
  color: #333;
}

.close-button {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
}

.close-button:hover {
  color: #333;
}

.modal-body {
  padding: 20px;
}

.upload-method-selector {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}

.method-btn {
  flex: 1 1;
  padding: 10px;
  border: 2px solid #e0e0e0;
  background: white;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.3s;
}

.method-btn.active {
  border-color: #4caf50;
  background: #4caf50;
  color: white;
}

.url-upload,
.file-upload {
  margin-bottom: 20px;
}

.url-input,
.file-input {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-bottom: 15px;
}

.file-upload-label {
  display: inline-block;
  padding: 10px 20px;
  background: #f5f5f5;
  border: 2px dashed #ddd;
  border-radius: 4px;
  cursor: pointer;
  text-align: center;
  margin-bottom: 15px;
  width: 100%;
}

.file-upload-label:hover {
  background: #e9e9e9;
}

.file-info {
  margin-top: 10px;
}

.image-preview {
  margin: 15px 0;
  text-align: center;
}

.image-preview img {
  max-width: 100%;
  max-height: 200px;
  border-radius: 4px;
  border: 1px solid #eee;
}

.alt-text-input {
  margin-top: 20px;
}

.alt-text-input input {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.modal-footer {
  padding: 20px;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.cancel-btn,
.insert-btn {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: background 0.3s;
}

.cancel-btn {
  background: #f5f5f5;
  color: #666;
}

.cancel-btn:hover {
  background: #e0e0e0;
}

.insert-btn {
  background: #4caf50;
  color: white;
}

.insert-btn:hover:not(:disabled) {
  background: #45a049;
}

.insert-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
}
.error-message {
  color: #d32f2f;
  background: #ffebee;
  padding: 8px 12px;
  border-radius: 4px;
  margin: 10px 0;
  font-size: 14px;
  border-left: 3px solid #d32f2f;
}

.url-examples {
  margin-bottom: 10px;
  color: #666;
  font-size: 12px;
  background: #f5f5f5;
  padding: 8px;
  border-radius: 4px;
}

.preview-text {
  text-align: center;
  color: #888;
  font-size: 12px;
  margin-top: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/image-upload-modal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;AACd;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,eAAe;AACjB","sourcesContent":[".modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modal-content {\n  background: white;\n  border-radius: 8px;\n  /* width: 90%; */\n  /* max-width: 500px; */\n  max-height: 90vh;\n  overflow: auto;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);\n}\n\n.modal-header {\n  padding: 20px;\n  border-bottom: 1px solid #eee;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.modal-header h3 {\n  margin: 0;\n  color: #333;\n}\n\n.close-button {\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: #666;\n}\n\n.close-button:hover {\n  color: #333;\n}\n\n.modal-body {\n  padding: 20px;\n}\n\n.upload-method-selector {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 20px;\n}\n\n.method-btn {\n  flex: 1;\n  padding: 10px;\n  border: 2px solid #e0e0e0;\n  background: white;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: all 0.3s;\n}\n\n.method-btn.active {\n  border-color: #4caf50;\n  background: #4caf50;\n  color: white;\n}\n\n.url-upload,\n.file-upload {\n  margin-bottom: 20px;\n}\n\n.url-input,\n.file-input {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  margin-bottom: 15px;\n}\n\n.file-upload-label {\n  display: inline-block;\n  padding: 10px 20px;\n  background: #f5f5f5;\n  border: 2px dashed #ddd;\n  border-radius: 4px;\n  cursor: pointer;\n  text-align: center;\n  margin-bottom: 15px;\n  width: 100%;\n}\n\n.file-upload-label:hover {\n  background: #e9e9e9;\n}\n\n.file-info {\n  margin-top: 10px;\n}\n\n.image-preview {\n  margin: 15px 0;\n  text-align: center;\n}\n\n.image-preview img {\n  max-width: 100%;\n  max-height: 200px;\n  border-radius: 4px;\n  border: 1px solid #eee;\n}\n\n.alt-text-input {\n  margin-top: 20px;\n}\n\n.alt-text-input input {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n}\n\n.modal-footer {\n  padding: 20px;\n  border-top: 1px solid #eee;\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n}\n\n.cancel-btn,\n.insert-btn {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: background 0.3s;\n}\n\n.cancel-btn {\n  background: #f5f5f5;\n  color: #666;\n}\n\n.cancel-btn:hover {\n  background: #e0e0e0;\n}\n\n.insert-btn {\n  background: #4caf50;\n  color: white;\n}\n\n.insert-btn:hover:not(:disabled) {\n  background: #45a049;\n}\n\n.insert-btn:disabled {\n  background: #ccc;\n  cursor: not-allowed;\n}\n.error-message {\n  color: #d32f2f;\n  background: #ffebee;\n  padding: 8px 12px;\n  border-radius: 4px;\n  margin: 10px 0;\n  font-size: 14px;\n  border-left: 3px solid #d32f2f;\n}\n\n.url-examples {\n  margin-bottom: 10px;\n  color: #666;\n  font-size: 12px;\n  background: #f5f5f5;\n  padding: 8px;\n  border-radius: 4px;\n}\n\n.preview-text {\n  text-align: center;\n  color: #888;\n  font-size: 12px;\n  margin-top: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
